<template>
  <v-navigation-drawer
  clipped app permanent
  >
    <v-list dense>
      <template>
        <v-list-item
        v-for="item in items"
        :key="item.title"
        @click="go(item.route)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <template v-if="item.title === 'Вопросы'">
            <v-badge small left down color="green lighten-2">
              <span slot="badge" v-if="newChats !== 0">{{ newChats }}</span>
            </v-badge>
          </template>
          <template v-if="item.title === 'Заявления'">
            <v-badge small left down color="green lighten-2">
              <span slot="badge" v-if="newStatements !== 0">{{ newStatements }}</span>
            </v-badge>
          </template>
          <template v-if="item.title === 'Столовые'">
            <v-badge small left down color="red lighten-2" class="mx-1 px-1">
              <span slot="badge" v-if="badCafes !== 0">{{ badCafes }}</span>
            </v-badge>
            <div style="display:inline-block;width:15px;"></div>
            <v-badge small left down color="green lighten-2" class="mx-1 px-1">
              <span slot="badge" v-if="goodCafes !== 0">{{ goodCafes }}</span>
            </v-badge>
          </template>
          <template v-if="item.title === 'Контроллеры'">
            <v-badge small left down color="red lighten-2" class="mx-1 px-1">
              <span slot="badge" v-if="badControllers !== 0">{{ badControllers }}</span>
            </v-badge>
            <div style="display:inline-block;width:15px;"></div>
            <v-badge left color="green lighten-2" class="mx-1 px-1">
              <span slot="badge" v-if="goodControllers !== 0">{{ goodControllers }}</span>
            </v-badge>
          </template>
        </v-list-item>
      </template>
      <br />
      <v-divider></v-divider>

      <br>
      <v-divider></v-divider>
      <v-subheader class="px-4">
        <span>История</span>
        <v-spacer></v-spacer>
        <v-btn text small color="secondary"
        @click="showHistory()"
        >
          <v-icon small left>history</v-icon>
          ещё
        </v-btn>
      </v-subheader>
      <v-list-item
        v-for="item in memorizedTail"
        @click="go({ name: 'person', params: { personid: item.personid } })"
      >
        <v-list-item-content>
          <v-list-item-title v-text="item.fullname"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog
      v-model="dialogHistory"
      scrollable fullscreen
      persistent :overlay="false"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-toolbar flat fixed class="pr-4">
            <span>История</span>
            <v-spacer></v-spacer>
            <v-btn text icon @click="dialogHistory = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <ListPersons
            class="mt-5"
            :persons="memorized" :sort-by="null"
            @person="dialogHistory=false"
          ></ListPersons>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>
</template>

<script>
import ListPersons from '@/components/ListPersons.vue'
export default {
  name: 'AsideMenu',
  components: { ListPersons },
  data: () => ({
    pages: [
      {
        title: 'Клиенты',
        route: '/persons',
        icon: 'mood',
        scope: 'backoffice',
      },
      {
        title: 'Вопросы',
        route: '/support/chats',
        icon: 'contact_support',
        scope: 'operator',
      },
      {
        title: 'Заявления',
        route: '/support/statements',
        icon: 'contact_support',
        scope: 'backoffice',
      },
      {
        title: 'Платежи',
        route: '/payments',
        icon: 'account_balance_wallet',
        scope: 'bookkeeper',
      },
      {
        title: 'Платежи',
        route: '/payments',
        icon: 'account_balance_wallet',
        scope: 'operator',
      },
      {
        title: 'Отчёт',
        route: '/finances',
        icon: 'assignment',
        scope: 'bookkeeper',
      },
      {
        title: 'Отчёт по столовым',
        route: '/cafereports',
        icon: 'assignment',
        scope: 'bookkeeper',
      },
      {
        title: 'Отчёт по Веб машинам',
        route: '/wmreport',
        icon: 'assignment',
        scope: 'bookkeeper',
      },
      {
        title: 'Столовые',
        route: '/cafes',
        icon: 'local_cafe',
        scope: 'backoffice',
      },
      {
        title: 'Контроллеры',
        route: '/controllers',
        icon: 'transfer_within_a_station',
        scope: 'backoffice',
      },
      {
        title: 'Классное руководство',
        route: '/classheads',
        icon: 'class',
        scope: 'admin',
      },
      {
        title: 'Карты',
        route: '/cards',
        icon: 'credit_card',
        scope: 'admin',
      },
      {
        title: 'Импорт',
        route: '/importpersons',
        icon: 'group_add',
        scope: 'admin',
      },
      {
        title: 'Микросервисы',
        route: '/microservices',
        icon: 'timeline',
        scope: 'backoffice',
      },
      {
        title: 'Новости',
        route: '/newsarticles',
        icon: 'note',
        scope: 'admin',
      },
      {
        title: 'Планировщик',
        route: '/scheduler',
        icon: 'schedule',
        scope: 'hyperadmin',
      },
      {
        title: 'Пользователи',
        route: '/users',
        icon: 'person',
        scope: 'hyperadmin',
      },
      {
        title: 'Контрагенты',
        route: '/orgs',
        icon: 'domain',
        scope: 'admin',
      },
      {
        title: 'Школьные админы',
        route: '/schooladmins',
        icon: 'supervisor_account',
        scope: 'admin',
      },
    ],
    dialogHistory: false,
    newChats: 0,
    newStatements: 0,
    cafes: [],
    badCafes: 0,
    goodCafes: 0,
    badControllers: 0,
    goodControllers: 0
  }),
  computed: {
    memorized () {
      return this.$store.state.memorized.reverse()
    },
    memorizedTail () {
      return this.memorized.slice(0, 4)
    },
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    items () {
      return this.pages
        .filter(x => this.scopes.includes(x.scope))
        .reduce((r, x) => {
          if (!r.find(y => y.route === x.route)) r.push(x)
          return r
        }, [])
    }
  },
  methods: {
    async fetch () {
      setInterval(async () => {
        await Promise.all([
          this.fetchChatsCounter(),
          this.fetchStatementsCounter(),
          this.fetchCafesCounter(),
          this.fetchControllersCounter()
        ])
      }, 60000)
    },
    go (route) {
      this.dialogHistory = false
      this.$router.push(route)
    },
    showHistory () {
      this.dialogHistory = true
    },
    async fetchChatsCounter () {
      const { chats } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-chats',
        pl: {
          page: this.page,
          limit: 20
        }
      })
      this.chats = chats
      this.newChats = this.chats.filter(chat => !chat.lastmsg.operatorid).length
    },
    async fetchStatementsCounter () {
      const { statements } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-statements',
        pl: {
          status: 'Отправлено',
          limit: 200
        }
      })
      this.newStatements = statements.length
    },
    async fetchCafesCounter () {
      const { cafes } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-cafes',
        pl: {}
      })
      this.cafes = cafes.filter(x => x.locationid)
      const data = (await Promise.all([
        this.$store.dispatch('sioRequest', { topic: 'cafes-ip-online' }),
      ])).map(x => x.online)
      const iponline = data[0].reduce((r, x) => {
        r[x] = x
        return r
      }, {})
      this.badCafes = this.cafes.map(x => {
        x.iponline = !!iponline[x.cafeid]
        return x
      }).filter(x => !x.iponline).length
      this.goodCafes = this.cafes.filter(x => x.iponline && x.ipaddr).length
    },
    async fetchControllersCounter () {
      const { controllers } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-controllers'
      })
      this.controllers = controllers
      const data = await this.$store.dispatch('sioRequest', {
        topic: 'controllers-ip-online'
      })
      const online = data.online
        .reduce((r, x) => {
          r[x] = x
          return r
        }, {})
      this.badControllers = this.controllers.map(x => {
        x.online = !!online[x.controllerid]
        return x
      }).filter(x => !x.online && x.schools.length !== 0 && x.ipaddr).length
      this.goodControllers = this.controllers.filter(x => x.online === true && x.ipaddr).length
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
.history-block {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
